import { c as _c } from "react/compiler-runtime";
import { clsx } from '@libs/common-next';
import { BuildContextProvider } from '../../providers';
import SixTileCarousel from './SixTileCarousel';
import type { Tile6UpProps } from './types';
import './Tile6UpPromo.scss';
export default function Tile6UpPromo(t0) {
  const $ = _c(7);
  const {
    header,
    tiles,
    variant
  } = t0;
  const t1 = tiles.length < 6 && "xl-even-spacing";
  let t2;
  if ($[0] !== t1) {
    t2 = clsx("tile6up-promo", t1);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const classNames = t2;
  let t3;
  if ($[2] !== classNames || $[3] !== header || $[4] !== tiles || $[5] !== variant) {
    t3 = <BuildContextProvider><SixTileCarousel className={classNames} alignText="left" data-testid="six-tile-promo" header={header} tiles={tiles} variant={variant} overrideDefaultClass={true} /></BuildContextProvider>;
    $[2] = classNames;
    $[3] = header;
    $[4] = tiles;
    $[5] = variant;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}